const MASK_TEXT = "Número Protegido";

/**
 * Sanitiza un objeto de contacto basándose en los permisos del usuario logueado.
 * @param {object} contact - El objeto de contacto a sanitizar.
 * @param {object} user - El objeto del usuario logueado.
 * @returns {object} - El objeto de contacto sanitizado o el original.
 */
export const sanitizeContact = (contact, user) => {
  if (!contact || !user) {
    return contact;
  }
  
  const canView = user.profile === "admin" || user.profile === "superadmin" || user.canViewNumbers;

  if (canView) {
    return contact; // Devuelve el contacto original si tiene permiso
  }

  // Si no tiene permiso, devuelve una copia con los datos ocultos
  return {
    ...contact,
    number: MASK_TEXT, // Siempre ocultamos el número
    // Ocultamos el nombre solo si es idéntico al número original
    name: contact.name === contact.number ? MASK_TEXT : contact.name,
  };
};

/**
 * Sanitiza el contacto anidado dentro de un objeto ticket.
 * @param {object} ticket - El objeto ticket.
 * @param {object} user - El objeto del usuario logueado.
 * @returns {object} - El objeto ticket con su contacto sanitizado.
 */
export const sanitizeTicket = (ticket, user) => {
  if (!ticket || !ticket.contact) {
    return ticket;
  }
  
  return {
    ...ticket,
    contact: sanitizeContact(ticket.contact, user),
  };
};